import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import materialDeliveryDocumentListAction from './materialDeliveryDocumentList.action.json' with { type: 'json' }
import { materialDeliveryDocumentObject } from '../materialDeliveryDocumentObject'

export const materialDeliveryDocumentExpression = expression(materialDeliveryDocumentObject.shape)

const materialDeliveryDocumentListDefinition = defineAction({
  ...materialDeliveryDocumentListAction,
  input: z.object({
    filter: materialDeliveryDocumentExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      fileName: 'Arquivo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(materialDeliveryDocumentObject),
    count: z.number(),
  }),
})

export default materialDeliveryDocumentListDefinition
